@if (isDesktop()) {
  <iw-button
    class="cr-btn"
    #dropdownRef="fuDropdownTrigger"
    size="s"
    uiType="secondary"
    [inheritWidth]="false"
    [offsetX]="-110"
    (click)="$event.stopPropagation()"
    [fuDropdownTriggerFor]="dropdown"
    [isPressed]="dropdownRef.isDropdownOpened$ | async"
    (opened)="cr.onDropdownOpened()"
  >
    {{ "currencyRate.btn" | translate }}
    <fu-icon iconName="arrow" size="24"></fu-icon>
  </iw-button>
} @else {
  <iw-button class="cr-btn" size="s" uiType="secondary" (click)="openDialog()">
    {{ "currencyRate.btn" | translate }}
  </iw-button>
}

<fu-dropdown class="cr-dropdown" #dropdown [closeOnClick]="false">
  <iw-currency-rate-content #cr [dropdownView]="true" />
</fu-dropdown>
